<script lang="ts" setup>
const runtimeConfig = useRuntimeConfig();
const VITE_APP_TITLE = runtimeConfig.public.VITE_APP_TITLE;
const VITE_RECORD_NUMBER = runtimeConfig.public.VITE_RECORD_NUMBER;

const friendLinks = [
  { name: '阿里云', url: 'https://www.aliyun.com' },
  { name: '腾讯云', url: 'https://cloud.tencent.com' },
  // 添加更多友链
];
</script>

<template>
  <footer class="f-c flex-col w-full text-center bg-[#f1f5f5] text-[#333435] text-4 p-1 dark:bg-gray-800">
    <div class="flex flex-row text-sm">
      <div class="inline-flex text-gray-800 items-center dark:text-white/50">友情链接：</div>
      <ul class="list-none p-0 m-1">
        <li v-for="(link, index) in friendLinks" :key="index" class="inline mr-2 text-gray-500">
          <a :href="link.url" target="_blank" rel="noopener noreferrer" class="no-underline">{{ link.name }}</a>
        </li>
      </ul>
    </div>
    <div class="mt-1 text-sm text-gray-800 dark:text-white/60">
      Copyright © 2024 - 2025 {{ VITE_APP_TITLE }}
      <a href="https://beian.miit.gov.cn" target="_blank">{{ VITE_RECORD_NUMBER }}</a>
    </div>
  </footer>
</template>
